const empty_error = document.querySelector('.contact-form-error').dataset.error;
const invalid_error = document.querySelector('.contact-form-error').dataset.invalid;

// Form Validation
const inputRequiredFields = [...document.querySelectorAll(".contact-us-form__wrapper .field--input input[required]")];
console.log('testing', inputRequiredFields );
inputRequiredFields.forEach( field => {
    field.addEventListener('keyup', function(){
        if(field.value.trim() === ''){
            setErrorFor(field);
        }else {
            setSuccessFor(field);
        }

        if(field.type === 'email' && field.value != '') {
            if(!isEmail(field.value)){
                const errorMessage = invalid_error;
                setErrorFor(field, errorMessage);
            }else {
                setSuccessFor(field);
            }
        }
    })
}) 

const carryUsForm = document.getElementById("contact_form");
function validateForm (e) {
    isValid = true;
    e.preventDefault();
    checkInputs();
  //   console.log(isValid)
    if(isValid){
      carryUsForm.submit();
      return true;
    }else {
      focusForm();  
      return false;
    }
}

function checkInputs() {
    const requiredFields = document.querySelectorAll(".contact-us-form__wrapper .field--input input[required]");
    const inputFields = [...requiredFields] 
    inputFields.forEach( field => {
        if(field.value.trim() === ''){
            setErrorFor(field);
        }else {
            setSuccessFor(field);
        }

        if(field.type === 'email' && field.value != '') {
            if(!isEmail(field.value)){
                const errorMessage = invalid_error;
                setErrorFor(field, errorMessage);
            }else {
                setSuccessFor(field);
            }
        }
    });
}

function setErrorFor(input, errorMessage = '') {
    const formControl = input.parentElement;
    const small = formControl.querySelector('small');
    formControl.classList.add('error');
    
    const label = formControl.querySelector('label');
    const messagePrefix =  label.textContent.replace("*", "");
    const message = `${messagePrefix}` + ` ${empty_error}`
    small.innerText = errorMessage != '' ? errorMessage : message;
    isValid = false;
  }
  
  function setSuccessFor(input) {
    const formControl = input.parentElement;
    const small = formControl.querySelector('small');
    small.innerText = ''
    formControl.classList.remove('error');
  }

  function focusForm(){
    const inputRequiredFields = [...document.querySelectorAll(".contact-us-form__wrapper .field--input input[required]")];
    let  inValidElem = []
    inputRequiredFields.forEach( field => {
        if(field.value.trim() === ''){
            inValidElem.push(field)
        }   
        if(field.type === 'email' && field.value != '') {
            if(!isEmail(field.value)){
                inValidElem.push(field)
            }
        }    
    })
    if(inValidElem.length > 0) { inValidElem[0].focus(); }   
}

  function isEmail(email) {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      email
    );
  }


  